import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AgendasService } from '../../services/agendas.service';
import { ConnectionService, ConnectionState } from 'ng-connection-service';

const ENVIADO = 'enviado';
@Component({
  selector: 'app-agendas-card-item',
  templateUrl: './agendas-card-item.component.html',
  styleUrls: ['./agendas-card-item.component.scss']
})
export class AgendasCardItemComponent implements OnInit {

  @Input() card: any;
  @Input() isLastCardItem: boolean;
  @Input() estado: string;
  @Input() currentPage: number;
  id: number;
  fechaInicio: Date;
  fechaFin: Date;
  submitted = false;
  isOnline = true;
  invalidDates = false;
  fecha: Date;

  constructor(
    private router: Router,
    private agendasService: AgendasService,
    private connectionService: ConnectionService
  ) { }

  ngOnInit(): void {
    this.connectionService.monitor().subscribe((connected: ConnectionState) => {
      this.isOnline = connected.hasNetworkConnection;
    })
    this.isOnline = JSON.parse(localStorage.getItem('isStillOnline'));

    const dateInitial = this.card.fechaInicio;
    this.fechaInicio = this._standarizeDate(dateInitial);
    const dateEnd = this.card.fechaFin;
    this.fechaFin = this._standarizeDate(dateEnd);
    this.fecha = this._standarizeDate(this.card.fecha);
  }

  seeFormAgenda(cardItem: any) {
    this.submitted = true;

    if(this.fechaFin != null && this.fechaFin < this.fechaInicio) {
      this.invalidDates = true;
      return;
    } else {
      this.invalidDates = false;
    }
    if(this.fechaInicio != null && this.fechaFin != null && this.isOnline && this.estado!=ENVIADO) {

      cardItem.fechaFin = this.fechaFin.toISOString().split('T')[0];
      cardItem.fechaInicio = this.fechaInicio.toISOString().split('T')[0];
      this.agendasService.updateDataAgenda(cardItem);

      this.id = this.card.idLote;
      let url = `agendas/${this.id}`;

      this.router.navigate([url], { queryParams: { page: this.currentPage }});
    }
  }

  _standarizeDate(date: string | null) {
    if (date) {
        let splitedDate = date.replace(/\//g, '-');
        const dateParts = splitedDate.split('-');
        if (date.includes('/')) {
            return new Date(parseInt(dateParts[2]), parseInt(dateParts[1]) - 1, parseInt(dateParts[0]));
        } else {
            return new Date(parseInt(dateParts[0]), parseInt(dateParts[1]) - 1, parseInt(dateParts[2]));
        }
    } else {
        return null;
    }
  }

}
